// @flow
import React from 'react'

type Props = {
  pathProps?: any,
  svgProps?: any,
}

export default (props: Props) => {
  const pathProps = props.pathProps || {}
  const svgProps = props.svgProps || {}
  return (
    <svg width="12px" height="10px" viewBox="0 0 12 10" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
      <g stroke="none" fill="none">
        <g transform="translate(-1272.000000, -123.000000)" stroke="#617182">
          <g transform="translate(1256.000000, 56.000000)">
            <g transform="translate(16.000000, 64.000000)">
              <path
                d="M11.4955825,6.47527572 L11.4955849,6.47522403 C11.6340078,3.55998327 8.44653772,2.41525936 6.62610392,4.75046005 C6.31119249,5.15487577 5.69055788,5.16043323 5.37330201,4.75510612 C3.55380997,2.43700923 0.403190746,3.54159844 0.502293417,6.40287968 C0.554716653,7.91438018 1.16969558,8.9799129 2.59188172,10.3189965 C2.82726131,10.5406221 3.08293306,10.769807 3.42961006,11.0723437 C3.49843869,11.1324089 4.15360074,11.7005316 4.35408275,11.8765219 C5.30286299,12.7092079 6.71498214,12.7078051 7.65798834,11.8724367 C7.85479758,11.698082 8.53733561,11.1004486 8.67506519,10.9786544 C9.04723448,10.6495454 9.32493456,10.3954463 9.57619529,10.151053 C10.8584203,8.90387309 11.4288674,7.88339846 11.4955825,6.47527572 Z"
                {...pathProps}
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
